import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturesPage from './components/FeaturesPage';
import ProductPage from './components/ProductPage';
import GlobalImpactPage from './components/GlobalImpactPage';
import GetStartedSection from './components/GetStartedSection';
import LogoMarquee from './components/LogoMarquee';
import TestimonialsPage from './components/TestimonialsPage';
import ContactFormPage from './components/ContactFormPage';
import SubscribeForm from './components/SubscribeForm';
import Footer from './components/Footer';
import AboutUsPage from './components/AboutUsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import SecurityPolicy from './components/SecurityPolicy';
import Documentation from './components/Documentation';
import SupportPage from './components/SupportPage';
// Loader removed

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('home');
  // Loader state removed

  // Handle navigation (no loader)
  useEffect(() => {
    const handleNavigation = () => {
      const hash = window.location.hash;
      if (hash === '#about') return setCurrentPage('about');
      if (hash === '#privacy') return setCurrentPage('privacy');
      if (hash === '#terms') return setCurrentPage('terms');
      if (hash === '#security') return setCurrentPage('security');
      if (hash === '#docs') return setCurrentPage('docs');
      if (hash === '#support') return setCurrentPage('support');
      return setCurrentPage('home');
    };

    window.addEventListener('hashchange', handleNavigation);
    handleNavigation();
    return () => window.removeEventListener('hashchange', handleNavigation);
  }, []);

  useEffect(() => {
    // Load sample data
    const loadData = async () => {
      try {
        const response = await fetch('/data/sample.json');
        const jsonData = await response.json();
        setData(jsonData);
      } catch (error) {
        console.error('Error loading data:', error);
        // Fallback data
        setData({
          site: {
            title: "FlowMatic™",
            tagline: "Where AI works, you win!",
            description: "Intelligent AI automation solutions to scale acquisition, operations, and support."
          },
          navigation: { primary: [], actions: [] },
          footer: { company: {}, products: [], resources: [], legal: [], social: [] }
        });
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Error Loading Content</h1>
          <p className="text-gray-600">Please refresh the page to try again.</p>
        </div>
      </div>
    );
  }

  // Render About Us page
  if (currentPage === 'about') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <AboutUsPage />
      </main>
    );
  }

  // Render Privacy Policy page
  if (currentPage === 'privacy') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <PrivacyPolicy />
      </main>
    );
  }

  // Render Terms of Service page
  if (currentPage === 'terms') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <TermsOfService />
      </main>
    );
  }

  // Render Security Policy page
  if (currentPage === 'security') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <SecurityPolicy />
      </main>
    );
  }

  // Render Documentation page
  if (currentPage === 'docs') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <Documentation />
      </main>
    );
  }

  // Render Support page
  if (currentPage === 'support') {
    return (
      <main className="min-h-screen">
        <Navbar navigation={data.navigation} />
        <SupportPage />
      </main>
    );
  }

  // Render main website
  return (
    <main className="min-h-screen">
      <Navbar navigation={data.navigation} />
      <div data-section="hero" id="hero">
        <Hero siteData={data.site} />
      </div>
      <div data-section="features" id="features">
        <FeaturesPage />
      </div>
      <div data-section="products" id="products">
        <ProductPage />
      </div>
      <div data-section="global-impact">
        <GlobalImpactPage />
      </div>
      <div data-section="get-started">
        <GetStartedSection />
      </div>
      <div data-section="logo-marquee">
        <LogoMarquee />
      </div>
      <div data-section="testimonials">
        <TestimonialsPage />
      </div>
      <div data-section="contact" id="contact">
        <ContactFormPage />
      </div>
      <div data-section="subscribe">
        <SubscribeForm />
      </div>
      <div data-section="footer">
        <Footer footerData={data.footer} />
      </div>
    </main>
  );
}

export default App;

